// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".player-box[data-v-10c28031]{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;background:#f4f5f5;border-radius:20px;padding:0 25px}.play-btn[data-v-10c28031],.player-box[data-v-10c28031]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.play-btn[data-v-10c28031]{cursor:pointer;font-size:25px;margin-right:10px}.slider[data-v-10c28031]{width:calc(100% - 170px);margin-left:20px}", ""]);
// Exports
module.exports = exports;
